import { render, staticRenderFns } from "./Experiences.vue?vue&type=template&id=830f01ba&"
import script from "./Experiences.vue?vue&type=script&lang=js&"
export * from "./Experiences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports